import React from 'react';
import { useState, useEffect } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import LoaderButton from './components/LoaderButton';
import { Text, TextOnly } from './components/Text';
import { finishResetSupportUserMfaEnrollment, getIsValidResetMfaEnrollmentCode } from './libs/db-lib';
import { toast } from 'react-toastify';
import { Loading } from './components/Loading';

const ResetMfaEnrollment = () => {
  const history = useHistory();
  const { resetMfaEnrollmentCode } = useParams<{ resetMfaEnrollmentCode?: string }>();

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const [totp, setTotp] = useState<string>('');
  const [isLoadingSubmit, setIsLoadingSubmit] = useState<boolean>(false);

  const [isInvalidCode, setIsInvalidCode] = useState<boolean>(false);

  const handleFinishResetSupportUserMfaEnrollment = async () => {
    setIsLoadingSubmit(true);

    const response = await finishResetSupportUserMfaEnrollment(resetMfaEnrollmentCode, totp);

    setIsLoadingSubmit(false);

    if (!response?.error) {
      toast.success(TextOnly('successfullyResetMfaEnrollment'), { containerId: 'standard' });
      setTimeout(() => {
        history.replace('/Login');
      }, 1500);
    } else {
      toast.error(TextOnly('failedToResetMfaEnrollment'), { containerId: 'standard' });
    }
  }

  useEffect(() => {
    const handleGetIsValidResetMfaEnrollmentCode = async () => {
      setIsLoading(true);

      const response = await getIsValidResetMfaEnrollmentCode(resetMfaEnrollmentCode);

      if (!response.error) {
        setIsInvalidCode(response !== true);
        setIsLoading(false);
      }
    }

    handleGetIsValidResetMfaEnrollmentCode();
  }, [resetMfaEnrollmentCode])

  return (
    <div className='flex-center-vertical-horizontal'>
      {isLoading ?
        <Loading />
        :
        <div>
          {isInvalidCode ?
            <div className='h1'>
              <Text tid='theProvidedLinkExpired' />
            </div>
            :
            <>
              <div>
                <Text tid={'pleaseEnterTheOtp'}/>
              </div>

              <div className="c-field u-margin-top-large ">
                <label
                  htmlFor="One-time Password"
                  className="c-field__label u-is-vishidden"
                >
                  <Text tid={'oneTimePassword'}/>
                </label>
                <input
                  type="text"
                  id="filter"
                  maxLength={50}
                  className="c-input u-font-mono l-container-center u-width-50-percent"
                  placeholder={TextOnly('oneTimePassword')}
                  value={totp}
                  onChange={(e) => {
                    setTotp(e.target.value)
                  }}
                />
              </div>

              <div className="l-flex-center u-margin-top-large">
                <LoaderButton
                  onClick={() => {
                    handleFinishResetSupportUserMfaEnrollment()
                  }}
                  className="c-btn"
                  disabled={!((totp ?? '').length === 6) || isLoadingSubmit}
                  isLoading={isLoadingSubmit}
                  text={TextOnly('submit')}
                  loadingText={TextOnly('submitting')}
                />
              </div>
            </>
          }
        </div>
      }
    </div>
  )
};

export default ResetMfaEnrollment;
